<template>
  <div class='' v-loading='loading'>

    <el-dialog class='gDia' :title="$t('app_tip')" v-model="isTipUnlock" size="tiny">
      <p>{{mkunlocktip}}</p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="uniSubmit(false)">{{$t('app_no')}}</el-button>
        <el-button type="primary" @click="uniSubmit(true)">{{$t('app_yes')}}</el-button>
      </div>
    </el-dialog>


    <el-row class='gPageBorder  gPdTB'>

      <p class='gFormTT'>{{$t('app_lockinfo')}}</p>
      
      
      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_deviceName') ">
            {{detail?detail.terminalName: ''}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowRightForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_deviceNo') ">
            {{detail?detail.terminalNo: ''}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('lin_global.risk_type') ">
            {{detail? getWarnTypes[detail.eventType]: ''}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowRightForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_riskdetail') ">
            {{disStrProcess(detail?detail.outDistance: '')}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_lockcity') ">
            {{detail?detail.cityNow: ''}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowRightForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_locklngandlat') ">
            {{detail? '{' + detail.longitude + ' , ' + detail.latitude + '}': ''}}
          </el-form-item>
        </el-form>
      </el-col>


      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_locktime') ">
            {{detail?detail.lockTime: ''}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowRightForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('lin_global.remark') ">
            {{detail?detail.lockDesc: ''}}
          </el-form-item>
        </el-form>
      </el-col>

    </el-row>

    <el-row class='gPageBorder gTopMg gPdTB'>
      <p class='gFormTT'>{{$t('app_risksetting')}}</p>
      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-button  :disabled="!detail.riskId" type='' style='border-radius:35px;position:absolute;right:calc(50% + 5px);z-index:10' size='small' @click='setUnbind(null)'>{{$t('app_unbindenclosure')}}</el-button>
          <el-form-item :label="$t('app_bindenclosure') ">
            {{detail?detail.riskName: ''}}
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <el-button class='gTopMg' @click='$router.go(-1)'>{{$t('app_cancel')}}</el-button>
    <el-button type='primary' :disabled="this.info.status == 2" class='gTopMg' @click="unlockBf">{{$t('lin_btn.unlock')}}</el-button>
    
  </div>
</template>
<script>
  import axios from 'axios'
  import { baseurl,urlAssets } from '../../api/url'
  export default{
    data(){
      return{
        isTipUnlock: false,
        getWarnTypes: {
					'0': this.$t('app_bglock'),
					'1': this.$t('lin_global.ccwl')
				},
				getDvTypes: {
					'0': this.$t('app_request'),
					'1': this.$t('app_unrequest')
        },
        detail: '',
        loading: false,
        ahref:'',
        isUnbind: false,
        certinfo:{},
        info: '',
        warnTypes: [
          {vl: '0', label: this.$t('')}
        ],
        dvTypes: [

        ]
      }
    },
    created () { 
      this.info = this.$getWObj().warnDetail
      this.getDetail()
    },
    computed: {
      mkunlocktip () {
        return this.$t('app_unldvwftip').replace('{wl}', this.detail.riskName)
      },
      unbindColor () {
        if (this.isUnbind) {
          return 'success'
        } else {
          return ''
        }
      }
    },
    methods:{
      unlockBf () {
        if (this.detail.riskName) {
          this.isTipUnlock = true
        } else {
          this.unlockReq()
        }
      },
      uniSubmit (is) {
        if (is) {
          this.isTipUnlock = false
          var _this = this
          this.setUnbind(()=> {
            _this.unlockReq()
          })
        } else {
          this.unlockReq()
        }
      },
      disStrProcess (dis) {
        if (dis) {
          return this.$t('lin_global.ccwl') + dis + 'KM'
        } else 
        {
          return ''
        }
      },
      getDetail () {
        this.loading = 1
        this.$getWarnDetail(this.info.id, (res) => {
          console.log(res)
          this.loading = 0
          if (res.status === 200) {
            this.detail = res.data
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          // error
        })
        
      },
      unlockReq () {
        this.loading = true
        this.$killwarn(this.detail.id, (res) => {
          this.loading = false
          if (res.status === 200) {
            this.$message.success(res.message)
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = false
        })
      },
      setUnbind (cb) {
        // this.isUnbind = !this.isUnbind
        this.loading = true
        this.$setFenceBind(this.detail.riskId, this.detail.terminalId, '1', (res) => {
          if (cb) {
            cb()
          }
          this.loading = false
          if (res.status === 200) {
            this.$message.success(res.message)
            this.getDetail()
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          if (cb) {
            cb()
          }
          this.loading = false
        })

      },
      uploadCer () {
        this.$setWObj('safeCerType', 0)
        this.$router.push({ path: '/certificate/mycer/upload' })
      },
      
    }
  }
</script>
<style>
  
  .astyle{
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #c4c4c4;
    color: #1f2d3d;
    padding: 10px 15px;
    margin-top:4px;
    border-radius: 4px;
    color: #fff;
    background-color: #20a0ff;
    border-color: #20a0ff;
  }

</style>



// WEBPACK FOOTER //
// warnDetail.vue?a5a5b736